<script setup>
//通用弹框
import { defineProps, defineEmits } from 'vue';
const props = defineProps({
    visible: {
        type: Boolean,
        required: true,
        default: false
    },
    title: {
        type: String,
        required: true,
        default: ''
    },
})
const emits = defineEmits(['update:visible',])
const handleClose = () => {
    emits('update:visible', false);
}
</script>
<template>
    <div class="modal fade show" style="display: block">
        <div class="modal-dialog modal-dialog-centered" style="width: 90% !important; max-width: 1600px !important;">
            <div class="modal-content my-dialog">
                <!-- head -->
                <div class="modal-header d-flex align-items-center" style="border-bottom: 1px solid #E9EBEC;">
                    <h5 class="modal-title">{{ props.title }}</h5>
                    <i class="ri-close-line btn-close cursor-pointer" @click="handleClose()"
                        style="color: #2E404C;background: unset; font-size: 26px; width: unset; height: unset;"></i>
                </div>
                <div class="modal-body my-scroll-bar" style="max-height: 800px; overflow-y: auto;">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
</template>
<style scoped lang="scss">
.my-dialog {
    // background-color: #9599AD;
    .modal-title {
        color: #2E404C;
    }
}
</style>